
import { defineComponent } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import AutoOnboardMixin from '~/mixins/autoOnboardMixin'

export default defineComponent({
  name: 'DeleteTemplateConfig',
  mixins: [AutoOnboardMixin, ActiveUserMixin],
  data() {
    return {
      deletingConfig: false,
      showConfirmDelete: false
    }
  },
  methods: {
    async deleteTemplate(close: () => void): Promise<void> {
      const { shortcode } = this.$route.params
      this.deletingConfig = true
      try {
        const res = await this.deleteConfigTemplate({
          shortcode
        })

        if (res.ok) {
          this.$toast.success('Deleted the template successfully')
          await this.refetchTemplateList()
          this.$router.push(this.$generateRoute(['settings', 'auto-onboard'], false, true))
          close()
        } else {
          throw new Error('Unable to delete config template')
        }
      } catch (e) {
        this.$toast.danger('There was a problem deleting this config')
        this.logErrorForUser(e as Error, 'Auto Onboard template deletion', {
          shortcode
        })
      } finally {
        this.deletingConfig = false
      }
    }
  }
})
